import Image from "../../../../src/gatsby-theme-docz/components/Image";
import GridCols from "../../../../src/gatsby-theme-docz/pages/docs/tokens/img/grid-cols.png";
import GridLayouts from "../../../../src/gatsby-theme-docz/pages/docs/tokens/img/grid-layouts.png";
import GridAround from "../../../../src/gatsby-theme-docz/pages/docs/tokens/img/grid-around.png";
import GridHoly from "../../../../src/gatsby-theme-docz/pages/docs/tokens/img/grid-holy.png";
import * as React from 'react';
export default {
  Image,
  GridCols,
  GridLayouts,
  GridAround,
  GridHoly,
  React
};